import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _createForOfIteratorHelper from "@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { Element, Editor, Range, Path } from 'slate'; // modified on the basic of slate function Editor.SplitNodes
// todo: split the node which nearest to the selection

var splitNodesAtPoint = function splitNodesAtPoint(editor) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  Editor.withoutNormalizing(editor, function () {
    var match = options.match,
        _options$at = options.at,
        at = _options$at === void 0 ? editor.selection : _options$at,
        _options$height = options.height,
        height = _options$height === void 0 ? 0 : _options$height,
        _options$always = options.always,
        always = _options$always === void 0 ? false : _options$always,
        _options$voids = options.voids,
        voids = _options$voids === void 0 ? false : _options$voids;

    if (match == null) {
      match = 'block';
    }

    if (Range.isRange(at)) {
      at = deleteRange(editor, at);
    }

    if (!at) {
      return;
    }

    var beforeRef = Editor.pointRef(editor, at, {
      affinity: 'backward'
    });
    var nodes = Editor.nodes(editor, {
      at: at,
      match: match,
      voids: voids
    });

    var highest = _toConsumableArray(nodes).pop();

    if (!highest) {
      return;
    }

    var voidMatch = Editor.match(editor, at, 'void');
    var nudge = 0;

    if (!voids && voidMatch) {
      var _voidMatch = _slicedToArray(voidMatch, 2),
          voidNode = _voidMatch[0],
          voidPath = _voidMatch[1];

      if (Element.isElement(voidNode) && editor.isInline(voidNode)) {
        var after = Editor.after(editor, voidPath);

        if (!after) {
          var text = {
            text: ''
          };
          var afterPath = Path.next(voidPath);
          Editor.insertNodes(editor, text, {
            at: afterPath,
            voids: voids
          });
          after = Editor.point(editor, afterPath);
        }

        at = after;
        always = true;
      }

      var siblingHeight = at.path.length - voidPath.length;
      height = siblingHeight + 1;
      always = true;
    }

    var afterRef = Editor.pointRef(editor, at);
    var depth = at.path.length - height;

    var _highest = _slicedToArray(highest, 2),
        highestPath = _highest[1];

    var lowestPath = at.path.slice(0, depth);
    var position = height === 0 ? at.offset : at.path[depth] + nudge;
    var target = null;

    var _iterator = _createForOfIteratorHelper(Editor.levels(editor, {
      at: lowestPath,
      reverse: true,
      voids: voids
    })),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
            node = _step$value[0],
            path = _step$value[1];

        var split = false;

        if (path.length < highestPath.length || path.length === 0 || !voids && Element.isElement(node) && editor.isVoid(node)) {
          break;
        }

        var _point = beforeRef.current;
        var isEnd = Editor.isEnd(editor, _point, path);

        if (always || !beforeRef || !Editor.isEdge(editor, _point, path)) {
          split = true;

          var _text = node.text,
              children = node.children,
              properties = _objectWithoutProperties(node, ["text", "children"]);

          editor.apply({
            type: 'split_node',
            path: path,
            position: position,
            target: target,
            properties: properties
          });
        }

        target = position;
        position = path[path.length - 1] + (split || isEnd ? 1 : 0);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    if (options.at == null) {
      var point = afterRef.current || Editor.end(editor, []);
      Editor.select(editor, point);
    }

    beforeRef.unref();
    afterRef.unref();
  });
},
    deleteRange = function deleteRange(editor, range) {
  if (Range.isCollapsed(range)) {
    return range.anchor;
  } else {
    var _Range$edges = Range.edges(range),
        _Range$edges2 = _slicedToArray(_Range$edges, 2),
        end = _Range$edges2[1];

    var pointRef = Editor.pointRef(editor, end);
    Editor.delete(editor, {
      at: range
    });
    return pointRef.unref();
  }
};

export default splitNodesAtPoint;